import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import reflect from "../../../assets/images/about.png"

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;

place-content: ${(props) => (props.pc ? props.pc : "center")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "600PX")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const BuyNow = styled.a`
text-decoration: none;
background-color: #166815;
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 25px;
padding: 10px 50px;
margin-right: 15px;
font-family:"Rockkb";
border:1px solid #000;
@media screen and (max-width:499px){
  padding: 8px 25px;

}

`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="4rem 0" id="about">
        <Container maxWidth="xl">
          <SectionHeading
            p="0"
            fs="50px"
            m="0"
            align="center"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >About
          </SectionHeading>
          <SectionHeading
            p="0"
            fs="50px"
            m="0"
            align="center"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >
            Pepedoge
          </SectionHeading>

          <JOiningLinks src={reflect} data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="500"
            data-aos-duration="600"
            data-aos-offset="0" />

          <P
            maxWidth="68%"
            p="0 0 40px 0"
            m="0"
            align="center"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="700"
            data-aos-duration="600"
            data-aos-offset="0"
          >
            PEPEDOGE is more than just a clever combination of two memes - it's a symbol of the power of creativity and imagination in the crypto space. This project is attracting a community of like-minded individuals who are excited about the potential of PEPEDOGE to shake up the industry and bring new life to the world of crypto memes. With its eye-catching design and growing popularity, PEPEDOGE is not just a token - it's a cultural phenomenon that is sure to make waves in the world of cryptocurrency.</P>
          
          <P
            maxWidth="68%"
            p="0 0 40px 0"
            m="0"
            align="center"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="700"
            data-aos-duration="600"
            data-aos-offset="0"
          >
            <b>Disclaimer:</b> PEPEDOGE is the world's most useless token, except when it's not. We cannot guarantee that PEPEDOGE will make you rich, but we can guarantee that it will make you laugh. PEPEDOGE can bring joy to your life despite having no inherent value or practical use. You could spend your money on a cup of coffee or a cheap hooker, or you could invest it in PEPEDOGE and be a part of something special.
            </P>
          

        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
